import { ReactNode, useState } from "react";
import { msalInstance } from "../../config/msalInstance";
import { getInitials } from "../../utils/format";
import GuideModal from "../docs/GuideModal";
import { HelpIcon, LogoutIcon } from "../ui/Icons";
import logoMark from "../../assets/logo-tw.svg";

interface IAppShellProps {
  user?: string;
  children: ReactNode;
}

export default function AppShell({ user, children }: IAppShellProps) {
  const [isGuideOpen, setIsGuideOpen] = useState<boolean>(false);

  const handleLogout = (): void => {
    sessionStorage.clear();
    localStorage.clear();
    msalInstance.logoutRedirect();
  };

  return (
    <div className="shell">
      <header className="topbar">
        <div className="brand">
          <span className="brand__mark">
            <img src={logoMark} alt="Teamwork" />
          </span>
          <span className="brand__text">
            <span className="brand__title">Mensajería Confirmación de Beneficio</span>
            <span className="brand__sub">Seguimiento de mensajería WhatsApp</span>
          </span>
        </div>

        <div className="topbar__spacer" />

        <button
          type="button"
          className="btn btn--sm btn--guide"
          onClick={() => setIsGuideOpen(true)}
          title="Abrir la guía de uso del sitio"
        >
          <HelpIcon size={15} />
          Guía de uso
        </button>

        {user && (
          <div className="account">
            <span className="account__mail" title={user}>
              {user}
            </span>
            <span className="account__avatar">{getInitials(user)}</span>
          </div>
        )}

        <button
          type="button"
          className="btn btn--sm btn--danger-ghost"
          onClick={handleLogout}
          title="Cerrar sesión"
        >
          <LogoutIcon size={15} />
          Salir
        </button>
      </header>

      <main className="main">{children}</main>

      {isGuideOpen && <GuideModal onClose={() => setIsGuideOpen(false)} />}
    </div>
  );
}
